import React from "react";
import { ValueTableRuleBuilder } from "../ValueTableRuleBuilder";
import { getValueTableBoolean } from "../Testing/TestDataSetup";
import { StoryNode } from "../../../../CommonUI/StoryBook/StoryData";

export const ValueTableBooleanStories = [
    new StoryNode(
        () => {
            let ruleDefinition = getValueTableBoolean();
            ruleDefinition.rows[0].cells[0].values = true;

            return <ValueTableRuleBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Value Table",
        "Boolean",
        "Value"
    ),

    new StoryNode(
        () => {
            let ruleDefinition = getValueTableBoolean();

            ruleDefinition.rows[0].cells[0].values = [false, true];

            return <ValueTableRuleBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Value Table",
        "Boolean",
        "List"
    ),
];
